var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "profile" }, [
        _c("div", { staticClass: "avatar" }, [
          _c("img", {
            attrs: {
              src:
                "https://cdn.discordapp.com/avatars/268758715014971392/47431b88cdb8b93ca1cb1c79868a50a9.png?size=64"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "username" }, [_vm._v("Tiniel Cerulis")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }